// "View as reseller" (the super admin's Resellers list): the website shows a reseller's pages, while the sign-in (the
// admin token) stays the super admin's. So the server still sees the super admin: it shows the reseller's figures
// where the page asks for them, and every change made is the super admin's (laravel CompanyScope, CommissionController).
//
// It ends with "Back as Admin" (header), on sign-out, and when the browser is closed: the mark below is kept in
// sessionStorage (one browser tab and the tabs opened from it), so the next visit after closing the browser opens as
// the super admin again.

const MARK = 'view_as_reseller';
// What a reseller's pages leave behind that would narrow the super admin's own pages
const LEFT_BEHIND = ['companyId', 'companyName', 'companyInfo', 'resellerId', 'resellerName'];

function get(storage, key) {
	try {
		return storage.getItem(key);
	} catch (e) {
		return null;
	}
}

function set(storage, key, value) {
	try {
		if (value === null || value === undefined) {
			storage.removeItem(key);
		} else {
			storage.setItem(key, value);
		}
	} catch (e) {
		// storage unavailable: nothing to keep
	}
}

// The reseller being viewed ({id, user}), or null when the super admin is not viewing as a reseller
export function viewingAs() {
	if (get(localStorage, 'main_admin_level') !== 'a' || get(localStorage, 'admin_level') !== 'b') {
		return null;
	}
	let user = null;
	try {
		user = JSON.parse(get(localStorage, 'mo_user'));
	} catch (e) {
		user = null;
	}
	return { id: get(localStorage, 'admin_id'), user };
}

// The super admin starts viewing as a reseller (their row from the Resellers list)
export function startViewAs(reseller) {
	if (get(localStorage, 'admin_level') !== 'a' || !reseller) {
		return false;
	}
	set(localStorage, 'mainadmin_id', get(localStorage, 'admin_id'));
	set(localStorage, 'main_mo_user', get(localStorage, 'mo_user'));
	set(localStorage, 'main_admin_level', 'a');
	set(localStorage, 'mo_user', JSON.stringify(reseller));
	set(localStorage, 'admin_level', 'b');
	set(localStorage, 'admin_id', String(reseller.id));
	LEFT_BEHIND.forEach((key) => set(localStorage, key, null));
	set(sessionStorage, MARK, String(reseller.id));
	return true;
}

// Back to the super admin, as they were before viewing as a reseller. Returns false when not viewing as one.
export function endViewAs() {
	if (get(localStorage, 'main_admin_level') !== 'a') {
		return false;
	}
	set(localStorage, 'admin_id', get(localStorage, 'mainadmin_id'));
	set(localStorage, 'mo_user', get(localStorage, 'main_mo_user'));
	set(localStorage, 'admin_level', 'a');
	['mainadmin_id', 'main_mo_user', 'main_admin_level'].concat(LEFT_BEHIND).forEach((key) => set(localStorage, key, null));
	set(sessionStorage, MARK, null);
	return true;
}

// When the website opens: viewing as a reseller in a browser that has since been closed ends it
export function endViewAsIfBrowserWasClosed() {
	if (get(localStorage, 'main_admin_level') === 'a' && get(sessionStorage, MARK) === null) {
		return endViewAs();
	}
	return false;
}
